import { AgencyWaitlistDialog } from "@/components/AgencyWaitlistDialog";
import { useI18n } from "@/lib/i18n";

export function AgencyCtaBanner() {
  const { t } = useI18n();
  return (
    <section className="py-24 px-6" style={{ backgroundColor: "#0a1845" }}>
      <div
        className="max-w-5xl mx-auto rounded-3xl p-10 md:p-16 text-center relative overflow-hidden"
        style={{
          backgroundColor: "#0e2058",
          border: "1px solid #163554",
        }}
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse at 50% 0%, rgba(232,114,26,0.18), transparent 70%)",
          }}
        />
        <div className="relative">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 text-white">
            {t("agency.cta.title")}
          </h2>
          <p className="text-lg mb-8" style={{ color: "#94a3b8" }}>
            {t("agency.cta.desc")}
          </p>
          <AgencyWaitlistDialog>
            <button
              style={{ backgroundColor: "#e8721a", boxShadow: "0 0 40px rgba(232,114,26,0.55)" }}
              className="inline-flex items-center justify-center rounded-full px-8 py-3.5 text-base font-semibold text-white hover:brightness-110 transition"
            >
              {t("agency.cta.button")}
            </button>
          </AgencyWaitlistDialog>
        </div>
      </div>
    </section>
  );
}
